import React from 'react';
import logoImg from '../static/images/moi-logo.svg';

import { Icon } from './Icon';

interface Props {
	onClick?: () => void;
	className: string;
	children: React.ReactNode;
}

const NavBar = ({ className, children }: Partial<Props>) => <div className={`menu-title ${className || ''}`}>{React.Children.toArray(children)}</div>;

export const Header: React.FC<Props> = (props: Props) => {
	return (
		<NavBar {...props}>
			<button
				className="off-canvas-menu-toggle"
				onClick={(e) => {
					e.preventDefault();
					if (props.onClick) {
						props.onClick();
					}
				}}
			>
				<Icon name="medium--menu" />
			</button>
			<img src={logoImg} alt="Moi" />
		</NavBar>
	);
};
